import React from 'react'

interface CardProps {
    children: React.ReactNode
}
export const Card = (props: CardProps) => {
  return (
    <>
        <div className="border rounded">
            {props.children}
        </div>
    </>
  )
}
